import * as amplitude from "@amplitude/analytics-browser";
import styled from "@emotion/styled";
import Fuse from "fuse.js";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { NETSUITE_PAGE_TITLE } from "../netsuite/constants";
import Store from "../stateStore";
import {
  getPlatformDetailsFromName,
  Platform,
  sendConnectionStartMetric,
  STORES,
} from "../utils";

interface Props {
  setStore: React.Dispatch<React.SetStateAction<STORES>>;
  platforms: any[];
}

const SelectPlatform = ({ setStore, platforms }: Props) => {
  const history = useHistory();
  const [shownPlatforms, setShownPlatforms] = useState(platforms) as any[];
  const [search, setSearch] = useState("");
  const fuse = new Fuse(platforms, {
    keys: ["name"],
    threshold: 0.2,
  });

  const stateStore = Store.useStore();
  const orgId = stateStore.get("orgId");
  const itemId = stateStore.get("itemId");

  useEffect(() => {
    if (platforms.length === 1) {
      selectPlatform(platforms[0]);
    }
    setShownPlatforms(platforms as any);
  }, [platforms]);

  useEffect(() => {
    if (search === "") {
      setShownPlatforms(platforms);
    }
  }, [platforms, search]);

  const searchPlatforms = (e: any) => {
    setSearch(e.target.value);
    if (search === "") {
      setShownPlatforms(platforms);
    } else {
      const result = fuse.search(search);
      setShownPlatforms(result.map((r: any) => r.item));
    }
  };

  const selectPlatform = (platform: Platform) => {
    // setStep((prev) => prev + 1);
    const { store, path } = getPlatformDetailsFromName(stateStore, platform);

    sendConnectionStartMetric({
      itemId,
      orgId,
      store,
      platform,
    });

    if (store === STORES.NETSUITE) {
      document.title = NETSUITE_PAGE_TITLE;
    }

    setStore(store);
    history.push(path + history.location.search);
  };
  return (
    <>
      <div className="p-4">
        <div className="pt-4 text-lg font-bold">Select your platform</div>
      </div>
      <input
        autoFocus
        className="m-2 mx-4 w-full font-lg outline-none"
        type="text"
        placeholder="Search"
        value={search}
        onChange={searchPlatforms}
      />
      <div className="mt-2">
        {shownPlatforms.map((platform: any) => {
          return (
            <HoverBackground
              key={platform.id}
              onClick={() => {
                amplitude.track("Platform Selected", {
                  platform: platform.name,
                });
                selectPlatform(platform);
              }}
              className="py-4 flex items-center"
              style={{ borderBottom: "1px solid #F2F2F2" }}
            >
              <div>
                <img
                  style={{ marginLeft: "1.6rem", height: "40px" }}
                  src={platform.logoUrl}
                  alt=""
                />
              </div>
              <div className="ml-3">{platform.displayName}</div>
            </HoverBackground>
          );
        })}
      </div>
    </>
  );
};

export default SelectPlatform;

const HoverBackground = styled.div`
  cursor: pointer;
  overflow: hidden;
  &:hover {
    background-color: #f2f2f2;
  }
`;
